export default "__VITE_ASSET__B1xG5SpG__"